import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import SettingsManager from "@/admin/SettingsManager";
import MediaManager from "@/admin/MediaManager";
import CategoriesManager from "@/admin/CategoriesManager";
import UsersManager from "@/admin/UsersManager";
import { PublicLayout } from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import Rubrique from "@/pages/Rubrique";
import ArticlePage from "@/pages/ArticlePage";
import PodcastPage from "@/pages/PodcastPage";
import MagazinePage from "@/pages/MagazinePage";
import ChroniquePage from "@/pages/ChroniquePage";
import AProposPage from "@/pages/AProposPage";
import EquipePage from "@/pages/EquipePage";
import SearchPage from "@/pages/SearchPage";
import AdminLogin from "@/admin/AdminLogin";
import { AdminLayout } from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import ArticlesManager from "@/admin/ArticlesManager";
import TickerManager from "@/admin/TickerManager";
import PodcastsManager from "@/admin/PodcastsManager";
import MagazinesManager from "@/admin/MagazinesManager";
import TeamManager from "@/admin/TeamManager";
import CommentsManager from "@/admin/CommentsManager";
import SubscribersManager from "@/admin/SubscribersManager";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/rubrique/:slug" element={<Rubrique />} />
              <Route path="/article/:slug" element={<ArticlePage />} />
              <Route path="/podcast" element={<PodcastPage />} />
              <Route path="/magazine" element={<MagazinePage />} />
              <Route path="/chronique" element={<ChroniquePage />} />
              <Route path="/a-propos" element={<AProposPage />} />
              <Route path="/a-propos/equipe" element={<EquipePage />} />
              <Route path="/recherche" element={<SearchPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<ArticlesManager />} />
              <Route path="ticker" element={<TickerManager />} />
              <Route path="podcasts" element={<PodcastsManager />} />
              <Route path="magazines" element={<MagazinesManager />} />
              <Route path="equipe" element={<TeamManager />} />
              <Route path="commentaires" element={<CommentsManager />} />
              <Route path="abonnes" element={<SubscribersManager />} />
              <Route path="medias" element={<MediaManager />} />
              <Route path="rubriques" element={<CategoriesManager />} />
              <Route path="administrateurs" element={<UsersManager />} />
              <Route path="parametres" element={<SettingsManager />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </SettingsProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
